export default {"src":"/_next/static/media/Arrow-Down-blue.a50de498.svg","height":24,"width":24};